const listForReplace = {
  gr8: 'Ultim8',
  PGSoftOriginal: 'PGSoft',
  '18peaches': '18 Peaches',
  rubiplay: 'RubyPlay',
  Gammatrade: 'Poly Trade',
};

export { listForReplace };
